var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operations-box"},_vm._l((_vm.getBtns),function(item,index){return _c('span',{key:index,staticClass:"btn",on:{"click":function($event){$event.stopPropagation();_vm.handleClick(item)}}},[_vm._v(_vm._s(item.value))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b52d24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IMTable/components/operations/index.vue
// module id = null
// module chunks = 